import { Outlet } from 'react-router-dom'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useSites, useHasSitesOnProduction } from 'store'
import MainContent, { TableContent } from 'components-shared'
import EmptyScreen from 'packages/ui/EmptyScreen'
import useSubscribeRefresh from 'use-subscribe-actions'

import { useSelection } from './store'
import Topbar from './Topbar'
import Table from './Table'
import { CardInMass } from './Card'
import React from 'react'

const Bypass = () => {
  const {t} = useTranslation()
  const [selection] = useSelection()
  const hasSitesOnProduction = useHasSitesOnProduction()
  const [{selected}] = useSites()
  const navigate = useNavigate()
  useSubscribeRefresh(() => navigate('/bypass'))
  return (
    <Stack flex={1}>
      {
        selected.length !== 1 || !hasSitesOnProduction
          ? <EmptyScreen icon="square-poll-vertical">{!hasSitesOnProduction ? t('ui_elements.service_soon') : t('ran.no_site_selected')}</EmptyScreen>
          : (
            <>
              <Topbar />
              <MainContent>
                <TableContent>
                  <Table />
                </TableContent>
                {
                  selection.length
                    ? <CardInMass />
                    : <Outlet />
                }
              </MainContent>
            </>
          )
      }
    </Stack>
  )
}

export default Bypass
